import { WarningIcon } from "@chakra-ui/icons";
import {
  Box,
  chakra,
  Text,
  Button,
  Flex,
  Avatar,
  Link,
  FormLabel,
  ModalHeader,
  Image,
  HStack,
  Input,
  ModalContent,
  Badge,
} from "@chakra-ui/react";

export const StyledModalHeader = chakra(ModalHeader, {
  baseStyle: {
    textAlign: "center",
    fontWeight: "bold",
    fontFamily: "Poppins",
    fontSize: "20px",
    mb: -2,
  },
});

export const Subtext = chakra(Text, {
  baseStyle: {
    textAlign: "center",
    fontSize: "14px",
    fontFamily: "Poppins",
    color: "#6B7280",
    mb: 6,
  },
});

export const PasswordHint = chakra(Text, {
  baseStyle: {
    fontSize: "12px",
    fontFamily: "Poppins",
    color: "gray.500",
    mt: 1,
  },
});

export const ToggleButton = chakra(Button, {
  baseStyle: {
    variant: "ghost",
    height: "20px",
    width: "12px",
    bg: "#FFFFFF",
  },
});

export const ResetPasswordButton = chakra(Button, {
  baseStyle: {
    w: "100%",
    bg: "#1819B4",
    color: "white",
    fontFamily: "Poppins",
    fontWeight: "bold",
    borderRadius: "10px",
    _hover: { bg: "#A996F8" },
  },
});

export const StyledFormLabel = chakra(FormLabel, {
  baseStyle: {
    fontWeight: "500",
    fontFamily: "Poppins",
    fontSize: "14px",
    color: "#2F2F34",
  },
});

export const PasswordChangedModalContainer = chakra(Box, {
  baseStyle: {
    background: "#FFF",
    borderRadius: "20px",
    padding: "40px 24px",
    maxWidth: "420px",
    w: "100%",
    textAlign: "center",
    boxShadow: `
      0px 3px 11px 0px rgba(24, 25, 180, 0.06),
      0px 10px 18px 0px rgba(24, 25, 180, 0.06)
    `,
  },
});

export const PasswordChangedHeading = chakra(Text, {
  baseStyle: {
    color: "#111827",
    fontSize: "16px",
    fontWeight: "700",
    fontFamily: "Poppins",
    mb: "10px",
  },
});

export const PasswordChangedSubtext = chakra(Text, {
  baseStyle: {
    fontSize: "16px",
    color: "#5C6670",
    fontWeight: "15px",
    fontFamily: "Poppins",
    mb: "24px",
  },
});

export const ContinueLoginButton = chakra(Button, {
  baseStyle: {
    w: "100%",
    h: "44px",
    bg: "#1819B4",
    color: "#fff",
    fontWeight: "600",
    fontSize: "14px",
    fontFamily: "Poppins",
    borderRadius: "8px",
    _hover: {
      bg: "#1516A0",
    },
  },
});
